/**
 * lib/storefront/wick_guide/multiple_wick_options.js
 */

class MultipleWickOptions {
  constructor(wick1, wick2) {
    this.primaryWick = wick1;
    this.secondaryWick = wick2;
    this.multipleRows = true;
  }

  get firstRow() {
    return this.primaryWick;
  }

  get secondRow() {
    return this.secondaryWick;
  }
}

export default MultipleWickOptions;
